export default __webpack_public_path__ + "assets/cfe59bd4349ba90a08bdb7cc2f090060.svg";